export default __webpack_public_path__ + "static/media/Addition_02.563026fc.png";